import { render, staticRenderFns } from "./internalExternalIssuesDetailAppr.vue?vue&type=template&id=88617d78"
import script from "./internalExternalIssuesDetailAppr.vue?vue&type=script&lang=js"
export * from "./internalExternalIssuesDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88617d78')) {
      api.createRecord('88617d78', component.options)
    } else {
      api.reload('88617d78', component.options)
    }
    module.hot.accept("./internalExternalIssuesDetailAppr.vue?vue&type=template&id=88617d78", function () {
      api.rerender('88617d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/iei/internalExternalIssuesDetailAppr.vue"
export default component.exports